// extracted by mini-css-extract-plugin
export default {"container":"V26QNOuVek_7s75TzVY1","handle":"CcE8MwVlUlksAR3qMeIi"};